<div class="filter offence-desc-tab" ngModelGroup="offenceDescGroup" #offenceDesc="ngModelGroup">
  <div class="offence-desc-tab__search-wrapper">
    <mat-form-field appearance="outline">
      <mat-icon matIconSuffix>search</mat-icon>
      <input matInput type="search" placeholder="Search"
        class="search-input"
        [(ngModel)]="searchValue"
        (ngModelChange)="onSearchChange($event)"
        [ngModelOptions]="{standalone: true}"
      >
    </mat-form-field>
    <div *ngIf="loading" class="loading">
      <mat-spinner></mat-spinner>
    </div>
  </div>
  <ng-container *ngIf="!loading">
    <div
      class="offence-desc-tab__select-all-wrapper"
      *ngIf="!hasNoMatch(); else notFound"
    >
      <mat-checkbox class="example-margin"
                    color="primary"
                    [checked]="allCompleted()"
                    [indeterminate]="someComplete()"
                    (change)="setAll($event.checked)"
      >
        All violation types
      </mat-checkbox>
    </div>
    <div *ngFor="let desc of descriptions">
      <mat-checkbox
        [(ngModel)]="desc.checked"
        [ngModelOptions]="{standalone: true}"
        (ngModelChange)="onChange()"
        color="primary"
        *ngIf="isShown(desc)"
      >
        {{desc.name}}
      </mat-checkbox>
      <input type="hidden" name="{{desc.name}}"
        [(ngModel)]="desc.checked"
      />
    </div>
  </ng-container>
</div>

<ng-template #notFound>
  No results found for <b>"{{searchValue}}"</b>
</ng-template>
